var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ei:plus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.0001 27.3801C9.98412 27.3801 5.12012 22.5161 5.12012 16.5001C5.12012 10.4841 9.98412 5.62012 16.0001 5.62012C22.0161 5.62012 26.8801 10.4841 26.8801 16.5001C26.8801 22.5161 22.0161 27.3801 16.0001 27.3801ZM16.0001 6.90012C10.6881 6.90012 6.40012 11.1881 6.40012 16.5001C6.40012 21.8121 10.6881 26.1001 16.0001 26.1001C21.3121 26.1001 25.6001 21.8121 25.6001 16.5001C25.6001 11.1881 21.3121 6.90012 16.0001 6.90012Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.2402 15.8604H21.7602V17.1404H10.2402V15.8604Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.3604 10.7402H16.6404V22.2602H15.3604V10.7402Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.ae42eeb44746715c05949c6294dcc2e7.svg";
export { ForwardRef as ReactComponent };